import React from "react";
import { Box, Button, Typography, Tooltip, ThemeProvider } from "@mui/material";
import { SuggestedSlotsTheme } from "../styles/SuggestedSlotsTheme";
import moment from "moment";
import { TRAVEL_BUFFER } from "../utils/Constants";
import { useTheme } from "@mui/material/styles";
import LeafSvg from "../images/LeafSvg";
//Import from marketbox core NPM package once published
export function humanizeTime(minutes) {
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;

    if (hours > 0 && mins > 0) {
        return `${hours} hr${hours > 1 ? "s" : ""} ${mins} min${mins > 1 ? "s" : ""}`;
    } else if (hours > 0) {
        return `${hours} hr${hours > 1 ? "s" : ""}`;
    } else {
        return `${mins} min${mins > 1 ? "s" : ""}`;
    }
}

export const SuggestedTime = ({
    suggestedTime,
    travelTime,
    travelDistance,
    distanceUnit,
    isSelected,
    onSelect,
    slot
}) => {
    return (
        <DayOrTimeSuggestion
            displayDayOrTime={moment(suggestedTime).format(
                "ddd, MMM D – h:mm A"
            )}
            travelTimeText={
                slot.wasEmptyDay
                    ? "Empty day, first booking"
                    : travelTime === 0
                      ? "Same location"
                      : !travelTime
                        ? `Empty block, first booking`
                        : `${humanizeTime(TRAVEL_BUFFER + travelTime)} travel`
            }
            travelDistanceText={
                travelTime > 0
                    ? `(${travelDistance.toFixed(1)}${distanceUnit})`
                    : ""
            }
            isSelected={isSelected}
            onSelect={() => onSelect(slot)}
            showLeafNoteTravelTime={slot.showLeafNoteTravelTime}
            showLeafNote={slot.showLeafNote}
        />
    );
};
export const SuggestedDay = ({
    suggestedDay,
    isSelected,
    onSelect,
    fullDay
}) => {
    return (
        <DayOrTimeSuggestion
            displayDayOrTime={
                isSelected.isSelectedDay && isSelected.fullDaySelectedTime
                    ? moment(isSelected.fullDaySelectedTime).format(
                          "ddd, MMM D – h:mm A"
                      )
                    : moment(suggestedDay).format("ddd, MMM D")
            }
            travelTimeText={
                isSelected.isSelectedDay && isSelected.fullDaySelectedTime
                    ? "First booking"
                    : "Empty day, book any time"
            }
            isSelected={isSelected.isSelectedDay}
            onSelect={() => onSelect(fullDay)}
        />
    );
};
export const DayOrTimeSuggestion = ({
    displayDayOrTime,
    travelTimeText,
    travelDistanceText = "",
    onSelect,
    showLeafNoteTravelTime,
    showLeafNote,
    isSelected
}) => {
    const theme = useTheme();
    return (
        <ThemeProvider theme={SuggestedSlotsTheme({ palette: theme.palette })}>
            <Box
                display={"flex"}
                alignItems={"center"}
                width={"100%"}
                position={"relative"}
                justifyContent={"center"}
            >
                <Button
                    variant={isSelected ? "contained" : "outlined"}
                    onClick={onSelect}
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        flexDirection: "column"
                    }}
                >
                    <Typography
                        variant="body2"
                        gutterBottom={false}
                        sx={{
                            color: isSelected
                                ? "white"
                                : theme.palette.text.main
                        }}
                    >
                        {displayDayOrTime}
                    </Typography>
                    <Typography
                        variant="helperText"
                        sx={{
                            color: isSelected
                                ? "white"
                                : theme.palette.helperText.main
                        }}
                    >
                        {`${travelTimeText} ${travelDistanceText}`}
                    </Typography>
                </Button>
                <Tooltip
                    placement="right"
                    arrow
                    title={
                        showLeafNoteTravelTime <= 5 && (
                            <Typography>
                                Less than 5 minutes travel time
                            </Typography>
                        )
                    }
                >
                    {showLeafNote && (
                        <span>
                            <LeafSvg />
                        </span>
                    )}
                </Tooltip>
            </Box>
        </ThemeProvider>
    );
};
